









export default

	props:
		item: Object
		index: Number
		sectionData: Object

	computed:

		layout: ->
			if @isEven @index then return 'right'
			else return 'left'

		block: -> {
			id: @sectionData.id
			backgroundColor: '#FFFFFF'
			buttons: []
			customTitle: null
			componentName: 'blocks-half-marquee'
			foregroundImage: []
			icon: []
			image: [
				landscape: @item.image
				portrait: []
			]
			layout: @layout
			showLines: false
			video: null
			videoLabel: null
			videoUrl: null
			table: {}
			copy: [
				"<span class='eyebrow'>Healthy Phenols</span>"
				"<h2 class='style-h2'>#{@item.text}</h1>"
				@item.body
			].join ' '
		}

	methods:
		isEven: (n) -> n % 2 == 0

